import { Collapse, FormControl, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../../components/Maincard";
import CustomAutocompleteComp from "../../newComponent/AutocompleteComp";
import CustomTextFieldComp from "../../newComponent/customTextFieldComp";
import ApplyFilterButton from "../../newComponent/NewButtonComp/ApplyFilterButton";
import ResetFilterButton from "../../newComponent/NewButtonComp/ResetFilterButton";
import { useGetTokenOrLogout } from "../../../utils/token";
import { useDateUtils } from "../../../utils/formatTime";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function StudentLeaveRequestFilter({
  open,
  setOpen,
  setIsLoading,
  setLeaveRequests,
  setSearchData,
  showSnackbar,
  originalData,
}) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
    const { todaysDate, oneMonthAgoDate } = useDateUtils();
  const [classList, setClassList] = useState([]);
  const [Classname, setClassname] = useState([]);
  const [TrainerList, setTrainerList] = useState([]);
  const [trainerName, setTrainerName] = useState([]);
  const [branchlist, setBranchlist] = useState([]);
  const [branch, setBranch] = useState([]);
  const [leaveFromeDate, setLeaveFromDate] = useState(oneMonthAgoDate);
  const [leaveToDate, setLeaveToDate] = useState(todaysDate);
  const [leaveRequestedFromDate, setLeaveRequestedFromDate] = useState(null);
  const [leaveRequestedToDate, setLeaveRequestedToDate] = useState(null);
  const [statusList, setStatusList] = useState([
    { id: 1, name: "Approved", value: "Approved" },
    { id: 2, name: "Pending", value: "Pending" },
    { id: 3, name: "Cancelled", value: "Cancelled" },
    { id: 4, name: "Denied", value: "Denied" },
  ]);
  const [status, setStatus] = useState([]);
  const [approvedBy, setapprovedBy] = useState([]);
  const [deniedBy, setDeniedBy] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}class`);
        if (response.ok) {
          const data = await response.json();
          setClassList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allclassList = [{ name: "Select All" }, ...classList];
  const handelClasschange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setClassname(classList);
    } else {
      setClassname(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/gettrainers/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          setTrainerList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allTrainerList = [{ first_name: "Select All" }, ...TrainerList];
  const handelTrainerName = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setTrainerName(TrainerList);
    } else {
      setTrainerName(value);
    }
  };

  const handleStausChange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setStatus(statusList);
    } else {
      setStatus(value);
    }
  };

  const handelApproveByName = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setapprovedBy(TrainerList);
    } else {
      setapprovedBy(value);
    }
  };

  const handelDeniedByName = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setDeniedBy(TrainerList);
    } else {
      setDeniedBy(value);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}branch`);
        if (response.ok) {
          const data = await response.json();

          setBranchlist(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allBranchList = [{ branch_name: "Select All" }, ...branchlist];
  const handelbranchchange = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchlist);
    } else {
      setBranch(value);
    }
  };

  const handleResetFilter = () => {
    setClassname([]);
    setTrainerName([]);
    setBranch([]);
    setStatus([]);
    setLeaveFromDate(oneMonthAgoDate);
    setLeaveToDate(todaysDate);
    setLeaveRequestedFromDate("");
    setLeaveRequestedToDate("");
    setapprovedBy([]);
    setDeniedBy([]);
    setLeaveRequests(originalData);
    setSearchData(originalData);
  };

  const handleApplyFilter = async (event) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    setIsLoading(true);
    const requestData = {
      class_id: Classname,
      start_date: leaveFromeDate || null,
      end_date: leaveToDate || null,
      approved_by: approvedBy?.map((i) => i.user_id),
      branch_id: branch?.map((i) => i.id),
      status: status?.map((i) => i.value),
      user_id: parseInt(userId),
      created_from_date :leaveRequestedFromDate || null,

      created_to_date :leaveRequestedToDate || null
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/std-leave-filter`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

          setLeaveRequests(result);
        setSearchData(result);
        setIsLoading(false);
      } else if (response.status === 404) {
        showSnackbar("Could't find any data", "error");
        setLeaveRequests([]);
        setSearchData([]);
        setIsLoading(false);
      } else {
        console.log("response", response)
        setLeaveRequests([]);
        setSearchData([]);
        setIsLoading(false);
        showSnackbar(response?.message, "error");
      }
    } catch (error) {
      setLeaveRequests([]);
      setSearchData([]);
      setIsLoading(false);

      showSnackbar("Error Fetching Data", "error");
    }
  };
  return (
    <>
      <Collapse in={open} sx={{ marginTop: open ? "5px" : 0 }}>
        <MainCard>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={3} sm={6} md={6}>
              <FormControl sx={{ mb: 1, width: "100%" }}>
                <Typography variant="h6">Class Details</Typography>

                <CustomAutocompleteComp
                  value={Classname}
                  multiple
                  onChange={handelClasschange}
                  options={allclassList}
                  getOptionLabel={(option) => option.name}
                  tooltipContent={(option) => option.name}
                />
              </FormControl>
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Trainer Details</Typography>

              <CustomAutocompleteComp
                value={trainerName}
                multiple
                onChange={handelTrainerName}
                options={allTrainerList}
                getOptionLabel={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
                tooltipContent={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Status</Typography>

              <CustomAutocompleteComp
                value={status}
                multiple
                onChange={handleStausChange}
                options={statusList}
                getOptionLabel={(option) => option?.name}
                tooltipContent={(option) => open?.name}
              />
            </Grid>

            <Grid item xs={12} lg={3} md={6} sm={6}>
              <Typography variant="h6">Branch</Typography>

              <CustomAutocompleteComp
                size="small"
                value={branch}
                multiple
                onChange={handelbranchchange}
                options={allBranchList}
                getOptionLabel={(option) => option.branch_name}
                tooltipContent={(option) => option.branch_name}
              />
            </Grid>
            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Leave From Date</Typography>
              <CustomTextFieldComp
                value={leaveFromeDate}
                onChange={(e) => setLeaveFromDate(e.target.value)}
                size="normal"
                fullWidth
                type="date"
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Leave To Date</Typography>
              <CustomTextFieldComp
                value={leaveToDate}
                onChange={(e) => setLeaveToDate(e.target.value)}
                size="normal"
                fullWidth
                type="date"
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Requested From Date</Typography>
              <CustomTextFieldComp
                value={leaveRequestedFromDate}
                onChange={(e) => setLeaveRequestedFromDate(e.target.value)}
                size="normal"
                fullWidth
                type="date"
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Requested To Date</Typography>
              <CustomTextFieldComp
                value={leaveRequestedToDate}
                onChange={(e) => setLeaveRequestedToDate(e.target.value)}
                size="normal"
                fullWidth
                type="date"
              />
            </Grid>

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Approved / Denied By</Typography>

              <CustomAutocompleteComp
                value={approvedBy}
                multiple
                onChange={handelApproveByName}
                options={allTrainerList}
                getOptionLabel={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
                tooltipContent={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
              />
            </Grid>

            {/* <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6">Denied By</Typography>

              <CustomAutocompleteComp
                value={deniedBy}
                multiple
                onChange={handelDeniedByName}
                options={allTrainerList}
                getOptionLabel={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
                tooltipContent={(option) =>
                  `${option.first_name ? option.first_name : ""} ${
                    option.last_name ? option.last_name : ""
                  }`
                }
              />
            </Grid> */}

            <Grid item xs={12} lg={3} sm={6} md={6}>
              <Typography variant="h6" visibility="hidden">
                Buttons
              </Typography>
              <Grid container gap={1}>
                <ApplyFilterButton onClick={handleApplyFilter} />
                <ResetFilterButton onClick={handleResetFilter} />
              </Grid>
            </Grid>
          </Grid>
        </MainCard>
      </Collapse>
    </>
  );
}
